import { Component, OnInit, Inject, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA, MatTableDataSource, MatSelect } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Province } from '@app/shared/models/province.model';
import { Locality } from '@app/shared/models/localty.model';
import { NeighborhoodService } from '@app/shared/services/neighborhood.service';
import { ToastService } from '@app/shared/services/toast.service';
import { Messages } from '@app/shared/enums/messages.enums';
import { ModalAlertComponent } from '../modal-alert/modal-alert.component';
import { LocalityNew } from '@app/shared/models/localty-new.model';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-places-modal',
  templateUrl: './places-modal.component.html',
  styleUrls: ['./places-modal.component.scss']
})
export class PlacesModalComponent implements OnInit, OnDestroy, AfterViewInit {
  localityForm: FormGroup;
  localities: Locality[] = [];
  public Filterlocalties: ReplaySubject<Locality[]> = new ReplaySubject<Locality[]>(1);
  @ViewChild('localitySelect') localitySelect: MatSelect;

  public dataSource: MatTableDataSource<any> = new MatTableDataSource();
  displayedColumns: string[] = [
    'name',
    'deleteButton',
  ];

  private _onDestroy = new Subject<void>();
  constructor(
    private toastService: ToastService,
    private neighborhoodService: NeighborhoodService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<PlacesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { BranchID: number },
  ) { }

  /**
   * Sets the initial value after the filteredBanks are loaded initially
   */
  private setInitialValue() {
    this.Filterlocalties
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.localitySelect.compareWith = (a: Locality, b: Locality) => a.id === b.id;
      });
  }
  ngAfterViewInit() {
    this.setInitialValue();
  }
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
  ngOnInit() {
    this.localityForm = this.fb.group({
      Locality: [null, Validators.required],
      LocalityFilter: [null]
    });
    this.getLocalities();
    this.getLocalitiesForBranch();

    // listen for search field value changes
    this.localityForm.get('LocalityFilter').valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterLocalities();
      });
  }
  private filterLocalities() {
    if (!this.localities) {
      return;
    }
    // get the search keyword
    let search = this.localityForm.get('LocalityFilter').value;
    if (!search) {
      this.Filterlocalties.next(this.localities.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.Filterlocalties.next(
      this.localities.filter(locality => locality.name.toLowerCase().indexOf(search) > -1)
    );
  }

  getLocalitiesForBranch() {
    this.neighborhoodService.getNeighborhoodsForBranch(this.data.BranchID).subscribe((localties) => this.dataSource.data = localties);
  }

  close(): void {
    this.dialogRef.close();
  }

  getLocalities(): void {
    this.neighborhoodService.getLocalities().subscribe((localties) => {
      this.localities = localties;
      this.localityForm.get('Locality').setValue(this.localities[0]);
      this.Filterlocalties.next(this.localities.slice());
    });
  }

  addLocalty(): void {
    const localityID = this.localityForm.get('Locality').value.id;
    const placeSearch = this.dataSource.data.find((place) => {
      return place.id === localityID;
    });

    if (placeSearch && Object.values(placeSearch).values) {
      this.toastService.error(Messages.allReadyExistLocalty);
      return;
    }


    const newLocalty = new LocalityNew();
    newLocalty.BranchID = this.data.BranchID;
    newLocalty.LocalityID = localityID;


    const dialog = this.dialog.open(ModalAlertComponent, {
      width: '600px',
      disableClose: true,
      data: {
        questionConfirm: Messages.areYouSureSave
      }
    });

    dialog.componentInstance.acceptFN.subscribe(_ => {
      this.neighborhoodService.saveLocalityForBranch(newLocalty).subscribe((localty) => {
        const newPlace = this.localities.find((place) => {
          return place.id === newLocalty.LocalityID;
        });
        this.dataSource.data.push(newPlace);

        const data = this.dataSource.data;
        this.dataSource.data = data;
        this.toastService.success(Messages.inserted);
      });
      dialog.close();
    });
  }

  deleteLocalty(localty: Locality): void {
    const deleteLocalty = new LocalityNew();
    deleteLocalty.BranchID = this.data.BranchID;
    deleteLocalty.LocalityID = localty.id;

    const dialog = this.dialog.open(ModalAlertComponent, {
      width: '600px',
      disableClose: true,
      data: {
        questionConfirm: Messages.areYouSureDelete
      }
    });

    dialog.componentInstance.acceptFN.subscribe(_ => {
      this.neighborhoodService.deleteNeighborhood(deleteLocalty).subscribe(() => {
        const item = this.dataSource.data.find(x => x.id === localty.id);
        const index = this.dataSource.data.indexOf(item);
        this.dataSource.data.splice(index, 1);

        const data = this.dataSource.data;
        this.dataSource.data = data;
        this.toastService.success(Messages.deleted);
      }, (error) => {
        this.toastService.error(error ? error : Messages.defaultError);
      });
      dialog.close();
    });
  }

}
